
export default {
  name: "LogoutInactivity",
  components: {
  },
  setup() {
  }

};
